import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-avatar-with-exchange',
  styleUrl: 'lab-ds-avatar-with-exchange.css',
  shadow: true,
})
export class LabDsAvatarWithExchange {
  @Event() clickAvatar: EventEmitter;

  handleClick() {
    if (this.disabled) return;
    this.clickAvatar.emit();
  }

  @Prop() size!: 'small' | 'medium' | 'large' | 'x-large' | 'xx-large' | 'x-small';

  @Prop() imageSRC: string;

  @Prop() disabled: boolean;

  @Prop() name: string;

  iconSize = {
    'small': 'xx-small',
    'medium': 'x-small',
    'large': 'small',
    'x-large': 'medium',
    'xx-large': 'medium',
  };

  render() {
    return (
      <div onClick={() => this.handleClick()} class={`avatar-with-exchange ${this.disabled ? 'disabled' : ''}`}>
        <lab-ds-avatar size={this.size} name={this.name} disabled={this.disabled} imageSRC={this.imageSRC} />
        <div class="overlay"></div>
        <lab-ds-icon-not-selectable class="exchange-icon" icon="photo_camera" size={this.iconSize[this.size]} />
      </div>
    );
  }
}
